/*
Sohel 11/21/2022 2700271704 Added Account Update Group API.
Akhila 06/21/2023 2700271704 conditionally disable save and finish button on submission
*/
import {createSlice} from '@reduxjs/toolkit';
import {httpGet, httpPost} from '../../../util/Rest';
import {submissionEnd} from '../CommonActions/commonActions';

const initialState = {
  loading: false,
  successMsg: null,
  errorMsg: null,
  addAccountUpdateGroupStatus: null,
  accountUpdateGroupData: {},
  allGroupCode: [],
};

const accountUpdateGroup = createSlice({
  name: 'accountUpdateGroup',
  initialState,
  reducers: {
    fetchStart: (state) => {
      state.loading = true;
      state.errorMsg = null;
    },
    fetchError: (state, action) => {
      state.errorMsg = action.payload;
      state.loading = false;
    },
    postAccountUpdateGroupData: (state, action) => {
      state.addAccountUpdateGroupStatus = action.payload?.status;
      state.loading = false;
      state.errorMsg = null;
      state.successMsg = action.payload?.message;
    },
    getAccountUpdateGroupData: (state, action) => {
      state.accountUpdateGroupData = action.payload;
      state.loading = false;
      state.errorMsg = null;
      state.addAccountUpdateGroupStatus = action.payload?.status;
    },
    getAllGroupCode: (state, action) => {
      state.allGroupCode = action.payload;
      state.loading = false;
      state.errorMsg = null;
    },
    resetMsg: (state) => {
      state.successMsg = null;
      state.errorMsg = null;
      state.loading = false;
      state.addAccountUpdateGroupStatus = null;
    },
    resetAddAccountGroupData: (state) => {
      state.accountUpdateGroupData = {};
      state.loading = false;
    },
  },
});
export default accountUpdateGroup.reducer;

const {
  fetchStart,
  fetchError,
  postAccountUpdateGroupData,
  getAccountUpdateGroupData,
  resetMsg,
  resetAddAccountGroupData,
  getAllGroupCode,
} = accountUpdateGroup.actions;

export const postAccountUpdateGroup = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`triggeraccount/save/triggerAccountupdate`, details)
      .then((data) => {
        dispatch(submissionEnd());
        if (data && data.status && data.status === 200) {
          dispatch(postAccountUpdateGroupData(data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const fetchAccountUpdateGroup = (groupCode) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`triggeraccount/find/triggers/${groupCode}`)
      .then((data) => {
        if (data?.status === 200 && data?.data?.status === 400) {
          dispatch(fetchError(data));
        } else if (data && data.status && data.status === 200) {
          dispatch(getAccountUpdateGroupData(data.response));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const fetchAllGroupCode = () => {
  return (dispatch) => {
    httpGet(`triggeraccount/find/all/groupCodeanddescription`)
      .then((data) => {
        if (data?.status && data.status === 200) {
          dispatch(getAllGroupCode(data?.response));
        } else {
          dispatch(fetchError(data?.message));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};
export const resetMessage = () => {
  return (dispatch) => {
    dispatch(resetMsg());
  };
};

export const resetAddAccountGroup = () => {
  return (dispatch) => {
    dispatch(resetAddAccountGroupData());
  };
};
